import {
  UPDATE_POPUP
} from './types';

/**
 *
 * @return {Function}
 */
const updatePopups = state => (dispatch, getState) => {
  const { popupState } = getState();
  if (popupState && popupState.preventInputChanges) return;
  dispatch({ type: UPDATE_POPUP, payload: state });
};

export default {
  updatePopups,
};



// WEBPACK FOOTER //
// ./src/actions/popup.js